import { useQuery } from "@tanstack/react-query";
import { getPublicAbout } from "@/lib/api";
import AboutView from "@/components/AboutView";

export default function AboutPage() {
  const q = useQuery({ queryKey: ["public-about"], queryFn: getPublicAbout, retry: 1 });
  return <AboutView data={q.data || {}} />;
}
